import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTheme } from '../ThemeContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SponsorTicker = () => {
  const [donors, setDonors] = useState([]);
  const { isInstitutional } = useTheme();

  useEffect(() => {
    axios.get(`${API_URL}/api/donations/wall`).then(r => {
      const all = r.data || [];
      const visible = all.filter(d => !d.anonymous).slice(0, 3);
      setDonors(visible.map(d => ({
        ...d,
        logo: d.company_name?.toLowerCase().includes('schedabusiness') ? '/sbp_logo_official.png' : d.brand_logo_url
      })));
    }).catch(() => {});
  }, []);

  const displayDonors = donors.length > 0
    ? donors
    : [
        { name: 'Marco Fondatore', comune: 'Firenze', belt: 'Nera' },
        { name: 'Sara Visionaria', comune: 'Siena', belt: 'Marrone' },
        { name: 'Luca Pioniere', comune: 'Valdelsa', belt: 'Gialla' },
      ];

  const tripled = [...displayDonors, ...displayDonors, ...displayDonors];

  const bgStyle = isInstitutional
    ? { height: '42px', background: '#1B2A4A' }
    : { height: '42px', background: 'linear-gradient(90deg, #0a0a0a, #111, #0a0a0a)' };

  const labelBg = isInstitutional ? '#C4532D' : '#CC0000';
  const fadeL = isInstitutional ? '#1B2A4A' : '#111';
  const fadeR = isInstitutional ? '#1B2A4A' : '#111';
  const textColor = isInstitutional ? '#FAF9F6' : '#fff';
  const subColor = isInstitutional ? '#8A96A5' : undefined;
  const dividerColor = isInstitutional ? '#C4532D' : undefined;

  return (
    <div data-testid="sponsor-ticker" className={`fixed bottom-0 left-0 right-0 z-[9990] border-t ${isInstitutional ? 'border-[#C4532D]/40' : 'border-red-600/60'}`}
      style={bgStyle}>
      <div className="flex items-end h-full">
        <div className="flex-shrink-0 h-full flex items-end pb-1 px-4" style={{ background: labelBg }}>
          <span className="text-[10px] font-black text-white uppercase tracking-wider whitespace-nowrap cnn-pulse"
            style={{ fontFamily: isInstitutional ? "'Titillium Web', sans-serif" : 'monospace' }}>
            VISIONARI IN MISSIONE
          </span>
        </div>

        <div className="flex-1 overflow-hidden relative">
          <div className="absolute inset-y-0 left-0 w-12 z-10" style={{ background: `linear-gradient(90deg, ${fadeL}, transparent)` }} />
          <div className="absolute inset-y-0 right-0 w-12 z-10" style={{ background: `linear-gradient(270deg, ${fadeR}, transparent)` }} />
          <div className="flex items-end pb-1 gap-12 animate-cnn-ticker whitespace-nowrap" style={{ width: 'max-content' }}>
            {tripled.map((d, i) => (
              <div key={i} className="flex items-center gap-3 flex-shrink-0">
                {d.logo ? (
                  <img src={d.logo} alt={d.company_name || d.name} className="h-7 w-auto" />
                ) : (
                  <span className="donor-shine font-black text-sm tracking-wide"
                    style={{ fontFamily: isInstitutional ? "'Titillium Web', sans-serif" : 'monospace', color: textColor }}>
                    {d.company_name || d.name}
                  </span>
                )}
                {d.comune && (
                  <span className="text-[10px]" style={{ fontFamily: isInstitutional ? "'Titillium Web', sans-serif" : 'monospace', color: subColor || '#71717a' }}>da {d.comune}</span>
                )}
                <span className="text-lg leading-none" style={{ color: dividerColor || '#ef4444', fontFamily: 'monospace' }}>|</span>
              </div>
            ))}
          </div>
        </div>

        <div className={`flex-shrink-0 px-4 pr-20 h-full flex items-end pb-1 border-l ${isInstitutional ? 'border-[#C4532D]/40' : 'border-red-600/40'}`}>
          <span className="text-[10px] font-mono opacity-40 whitespace-nowrap"
            style={{ color: isInstitutional ? '#FAF9F6' : '#00FF41' }}>&lt;/ COMMUNITY</span>
        </div>
      </div>

      <style>{`
        @keyframes cnnScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
        .animate-cnn-ticker {
          animation: cnnScroll 20s linear infinite;
        }
        .animate-cnn-ticker:hover {
          animation-play-state: paused;
        }
        @keyframes shimmer {
          0%, 100% { text-shadow: 0 0 4px rgba(255,255,255,0.3); }
          50% { text-shadow: 0 0 12px rgba(255,255,255,0.8), 0 0 24px rgba(255,255,255,0.4); }
        }
        .donor-shine {
          animation: shimmer 3s ease-in-out infinite;
        }
        @keyframes cnnPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.7; }
        }
        .cnn-pulse {
          animation: cnnPulse 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default SponsorTicker;
